import { render, staticRenderFns } from "./PerfilTeacher.vue?vue&type=template&id=52641fbc&scoped=true"
import script from "./PerfilTeacher.vue?vue&type=script&lang=js"
export * from "./PerfilTeacher.vue?vue&type=script&lang=js"
import style0 from "./PerfilTeacher.vue?vue&type=style&index=0&id=52641fbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52641fbc",
  null
  
)

export default component.exports